// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["SUBSCRIPTION_TYPE_UNSPECIFIED"] = "SUBSCRIPTION_TYPE_UNSPECIFIED";
    SubscriptionType["SUBSCRIPTION_TYPE_LOCATION"] = "SUBSCRIPTION_TYPE_LOCATION";
    SubscriptionType["SUBSCRIPTION_TYPE_USER"] = "SUBSCRIPTION_TYPE_USER";
    SubscriptionType["SUBSCRIPTION_TYPE_MAILBOX"] = "SUBSCRIPTION_TYPE_MAILBOX";
    SubscriptionType["SUBSCRIPTION_TYPE_ORG"] = "SUBSCRIPTION_TYPE_ORG";
})(SubscriptionType || (SubscriptionType = {}));
export var SubscriptionType_index;
(function (SubscriptionType_index) {
    SubscriptionType_index[SubscriptionType_index["SUBSCRIPTION_TYPE_UNSPECIFIED"] = 0] = "SUBSCRIPTION_TYPE_UNSPECIFIED";
    SubscriptionType_index[SubscriptionType_index["SUBSCRIPTION_TYPE_LOCATION"] = 1] = "SUBSCRIPTION_TYPE_LOCATION";
    SubscriptionType_index[SubscriptionType_index["SUBSCRIPTION_TYPE_USER"] = 2] = "SUBSCRIPTION_TYPE_USER";
    SubscriptionType_index[SubscriptionType_index["SUBSCRIPTION_TYPE_MAILBOX"] = 3] = "SUBSCRIPTION_TYPE_MAILBOX";
    SubscriptionType_index[SubscriptionType_index["SUBSCRIPTION_TYPE_ORG"] = 4] = "SUBSCRIPTION_TYPE_ORG";
})(SubscriptionType_index || (SubscriptionType_index = {}));
/**
 * MessageAction : represents various actions in the messages over the connection
 */
export var MessageAction;
(function (MessageAction) {
    MessageAction["MESSAGE_ACTION_UNSPECIFIED"] = "MESSAGE_ACTION_UNSPECIFIED";
    MessageAction["MESSAGE_ACTION_PING"] = "MESSAGE_ACTION_PING";
    MessageAction["MESSAGE_ACTION_PONG"] = "MESSAGE_ACTION_PONG";
    MessageAction["MESSAGE_ACTION_CLOSE"] = "MESSAGE_ACTION_CLOSE";
    MessageAction["MESSAGE_ACTION_SUBSCRIBE"] = "MESSAGE_ACTION_SUBSCRIBE";
    MessageAction["MESSAGE_ACTION_UNSUBSCRIBE"] = "MESSAGE_ACTION_UNSUBSCRIBE";
    MessageAction["MESSAGE_ACTION_NOTIFICATION"] = "MESSAGE_ACTION_NOTIFICATION";
    MessageAction["MESSAGE_ACTION_ERROR"] = "MESSAGE_ACTION_ERROR";
})(MessageAction || (MessageAction = {}));
export var MessageAction_index;
(function (MessageAction_index) {
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_UNSPECIFIED"] = 0] = "MESSAGE_ACTION_UNSPECIFIED";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_PING"] = 1] = "MESSAGE_ACTION_PING";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_PONG"] = 2] = "MESSAGE_ACTION_PONG";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_CLOSE"] = 3] = "MESSAGE_ACTION_CLOSE";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_SUBSCRIBE"] = 4] = "MESSAGE_ACTION_SUBSCRIBE";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_UNSUBSCRIBE"] = 5] = "MESSAGE_ACTION_UNSUBSCRIBE";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_NOTIFICATION"] = 6] = "MESSAGE_ACTION_NOTIFICATION";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_ERROR"] = 7] = "MESSAGE_ACTION_ERROR";
})(MessageAction_index || (MessageAction_index = {}));
/**
 * SubUnsubEntity: various entities by which we can subscribe/ unsubscribe for updates
 */
export var SubUnsubEntity;
(function (SubUnsubEntity) {
    SubUnsubEntity["SUBUNSUB_ENTITY_UNSPECIFIED"] = "SUBUNSUB_ENTITY_UNSPECIFIED";
    SubUnsubEntity["SUBUNSUB_ENTITY_LOCATION_IDS"] = "SUBUNSUB_ENTITY_LOCATION_IDS";
    SubUnsubEntity["SUBUNSUB_ENTITY_USER_IDS"] = "SUBUNSUB_ENTITY_USER_IDS";
    SubUnsubEntity["SUBUNSUB_ENTITY_ORG_IDS"] = "SUBUNSUB_ENTITY_ORG_IDS";
    SubUnsubEntity["SUBUNSUB_ENTITY_MAILBOX_IDS"] = "SUBUNSUB_ENTITY_MAILBOX_IDS";
})(SubUnsubEntity || (SubUnsubEntity = {}));
export var SubUnsubEntity_index;
(function (SubUnsubEntity_index) {
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_UNSPECIFIED"] = 0] = "SUBUNSUB_ENTITY_UNSPECIFIED";
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_LOCATION_IDS"] = 1] = "SUBUNSUB_ENTITY_LOCATION_IDS";
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_USER_IDS"] = 2] = "SUBUNSUB_ENTITY_USER_IDS";
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_ORG_IDS"] = 3] = "SUBUNSUB_ENTITY_ORG_IDS";
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_MAILBOX_IDS"] = 4] = "SUBUNSUB_ENTITY_MAILBOX_IDS";
})(SubUnsubEntity_index || (SubUnsubEntity_index = {}));
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["CONNECTION_STATUS_UNSPECIFIED"] = "CONNECTION_STATUS_UNSPECIFIED";
    ConnectionStatus["CONNECTION_STATUS_ESTABLISHED"] = "CONNECTION_STATUS_ESTABLISHED";
    ConnectionStatus["CONNECTION_STATUS_ERROR"] = "CONNECTION_STATUS_ERROR";
})(ConnectionStatus || (ConnectionStatus = {}));
export var ConnectionStatus_index;
(function (ConnectionStatus_index) {
    ConnectionStatus_index[ConnectionStatus_index["CONNECTION_STATUS_UNSPECIFIED"] = 0] = "CONNECTION_STATUS_UNSPECIFIED";
    ConnectionStatus_index[ConnectionStatus_index["CONNECTION_STATUS_ESTABLISHED"] = 1] = "CONNECTION_STATUS_ESTABLISHED";
    ConnectionStatus_index[ConnectionStatus_index["CONNECTION_STATUS_ERROR"] = 2] = "CONNECTION_STATUS_ERROR";
})(ConnectionStatus_index || (ConnectionStatus_index = {}));
export var Criteria_Type;
(function (Criteria_Type) {
    Criteria_Type["UNKNOWN"] = "UNKNOWN";
    Criteria_Type["LOCATION_ID"] = "LOCATION_ID";
    Criteria_Type["ORG_ID"] = "ORG_ID";
})(Criteria_Type || (Criteria_Type = {}));
export var Criteria_Type_index;
(function (Criteria_Type_index) {
    Criteria_Type_index[Criteria_Type_index["UNKNOWN"] = 0] = "UNKNOWN";
    Criteria_Type_index[Criteria_Type_index["LOCATION_ID"] = 1] = "LOCATION_ID";
    Criteria_Type_index[Criteria_Type_index["ORG_ID"] = 2] = "ORG_ID";
})(Criteria_Type_index || (Criteria_Type_index = {}));
export var Criteria_Condition;
(function (Criteria_Condition) {
    Criteria_Condition["MATCH_ANY"] = "MATCH_ANY";
    Criteria_Condition["MATCH_ALL"] = "MATCH_ALL";
})(Criteria_Condition || (Criteria_Condition = {}));
export var Criteria_Condition_index;
(function (Criteria_Condition_index) {
    Criteria_Condition_index[Criteria_Condition_index["MATCH_ANY"] = 0] = "MATCH_ANY";
    Criteria_Condition_index[Criteria_Condition_index["MATCH_ALL"] = 1] = "MATCH_ALL";
})(Criteria_Condition_index || (Criteria_Condition_index = {}));
export const WebSocketDirector = {
    /**
     * endpoints related to observability, debugging and health checks
     *
     * ObserveConnectionEstStats is used to observe the connection establishment statistics. It will be called
     * by the client as soon as the connection is established or failed and passes additional information like user,
     * location id to help us debug issues.
     */
    ObserveConnectionEstStats(fn, req) {
        return fn(`/websocket-director/v1/observe/connection-est-stats`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    TriggerNotification(fn, req) {
        return fn(`/websocket-director/v1/trigger-notification`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
